import React, { useState, useEffect } from 'react';
import { Input, Select_simple } from './ui';
import { optionsEncargadoProyecto, optionsTipoSubsidio, optionsPrograma, optionsAreaResponsable, optionsEstado, optionsPartido } from '../datos/options';
import InfoButtonWithPopover from "./InfoButtonWithPopover";

const FiltrosInicio = ({ 
    filters,
    setFilters,
    data,//datosOriginales,
    datosFiltrados,
    handleFilterChange,                                                                             
    limpiarFiltros
 }) => {
    
    console.log("DATA --->", data)

    const [partidosUnicos, setPartidosUnicos] = useState([]); //para partido_nombre
    const [organismosSolicitanteUnicos, setOrganismosSolicitanteUnicos] = useState([]); //para organismo_solicitante
    //por ahora no usar
    //const [estadosUnicos, setEstadosUnicos] = useState([]);
    //const [programasUnicos, setProgramasUnicos] = useState([]);


    // 1. función genérica
    const getUniqueAndFormattedItems = (data, propertyName) => {
        // Extrae y filtra los valores no vacíos o nulos
        const filteredItems = data
            .map(item => item[propertyName])
            .filter(item => item && item !== '');

        // Crea un Set con los valores únicos
        const uniqueItems = new Set(filteredItems);

        // Convierte el Set a un array y formatea los objetos
        return Array.from(uniqueItems).map(item => ({
            value: item,
            label: item
        }));
    };

    // 2. Unifica los efectos en un solo useEffect
    useEffect(() => {
        // Obtén y actualiza los partidos únicos
        const partidosUnicos = getUniqueAndFormattedItems(data, 'partido_nombre');//NO SE USA, usar optionsPartido
        setPartidosUnicos(partidosUnicos);

        // Obtén y actualiza los organismos solicitante únicos
        const organismosSolicitanteUnicos = getUniqueAndFormattedItems(datosFiltrados, 'organismo_solicitante'); //probar con datosFiltrados
        console.log("ORGANISMOS SOLICITANTE UNICOS --->", organismosSolicitanteUnicos)
        setOrganismosSolicitanteUnicos(organismosSolicitanteUnicos);

        // Obtén y actualiza los estados únicos
        //const estadosUnicos = getUniqueAndFormattedItems(data, 'estado');
        //setEstadosUnicos(estadosUnicos);
        
        //const programasUnicos = getUniqueAndFormattedItems(data, 'programa_lineamiento');
        //setProgramasUnicos(programasUnicos);

    }, [data, datosFiltrados]); // El efecto se ejecuta solo cuando 'data' cambia

    

    return (
        <div className="mb-6 p-4 bg-white dark:bg-gray-800 rounded-lg shadow-sm">
            <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg font-medium text-gray-900 dark:text-white">Filtros</h3>
                <button
                    onClick={limpiarFiltros}
                    className="px-3 py-1 text-sm text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300"
                >
                    Limpiar filtros
                </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Filtro por Encargado */}
                <div>
                    <label htmlFor="encargado_proyecto" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Responsable
                    </label>
                    <Select_simple
                        id="encargado_proyecto"
                        name="encargado_proyecto"
                        value={filters.encargado_proyecto}
                        onChange={handleFilterChange}
                        options={optionsEncargadoProyecto}
                        placeholder="Todos los responsables"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Filtro por Partido */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="partido_nombre" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            Partido
                        </label>                        
                    </div>                
                    <Select_simple
                        id="partido_nombre"
                        name="partido_nombre"
                        value={filters.partido_nombre}
                        onChange={handleFilterChange}
                        //options={partidosUnicos}
                        options={optionsPartido}
                        placeholder="Todos los partidos"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />                    
                </div>
                {/* Filtro por Organismo Solicitante */}
                <div>
                    <div className="flex items-center">
                        <label htmlFor="organismo_solicitante" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                            ONGs
                        </label>
                        <InfoButtonWithPopover infoText="Solo se muestran las ONGs donde hay proyectos" />
                    </div>
                    <Select_simple
                        id="organismo_solicitante"
                        name="organismo_solicitante"
                        value={filters.organismo_solicitante}
                        onChange={handleFilterChange}
                        options={organismosSolicitanteUnicos}
                        placeholder="Todas las ONGs"
                    //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 py-4">
                {/* Filtro por Area Responsable */}
                <div>
                    <label htmlFor="area_responsable" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Área Responsable
                    </label>
                    <Select_simple
                        id="area_responsable"
                        name="area_responsable"
                        value={filters.area_responsable}
                        onChange={handleFilterChange}
                        options={optionsAreaResponsable}
                        placeholder="Todas los áreas responsables"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>

                {/* Filtro por Tipo Subsidio */}
                <div>
                    <label htmlFor="tipo_subsidio" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Tipo Subsidio
                    </label>
                    <Select_simple
                        id="tipo_subsidio"
                        name="tipo_subsidio"
                        value={filters.tipo_subsidio}
                        onChange={handleFilterChange}
                        options={optionsTipoSubsidio}
                        placeholder="Todos los tipos de subsidio"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />
                </div>
                {/* Filtro por Programa */}
                <div>
                    <label htmlFor="programa" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Programa
                    </label>
                    <Select_simple
                        id="programa"
                        name="programa_lineamiento"
                        value={filters.programa_lineamiento}
                        onChange={handleFilterChange}
                        options={optionsPrograma}
                        placeholder="Todos los programas"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />                        
                </div>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                
                {/* Filtro por Estado */}
                <div>
                    <label htmlFor="estado" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Estado
                    </label>
                    <Select_simple
                        id="estado"
                        name="estado"
                        value={filters.estado}
                        onChange={handleFilterChange}
                        options={optionsEstado}
                        placeholder="Todos los estados"
                        //className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                    />                        
                </div>
                {/* Búsqueda general */}
                <div>
                    <label htmlFor="search" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        Buscar
                    </label>
                    <div className="relative">
                        <Input
                            type="text"
                            id="search"
                            name="search"
                            value={filters.search}
                            onChange={handleFilterChange}
                            placeholder="Buscar por nombre o expediente del proyecto..."
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white"
                        />
                        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                            </svg>
                        </div>
                    </div>
                </div>               
            </div>           
        </div>
    );
};

export default FiltrosInicio;
